import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { changePassword } from "../../api/auth";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { PasswordInput } from "../../components/neu/PasswordInput";
import { PasswordPair, passwordPairReady } from "../../components/neu/PasswordPair";
import { useApiError } from "../../hooks/useApiError";

const EMPTY = { current_password: "", new_password: "", confirm_password: "" };

export const PasswordForm = () => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const ready =
    Boolean(form.current_password) && passwordPairReady(form.new_password, form.confirm_password) && !busy;

  const submit = async (e) => {
    e.preventDefault();
    if (!ready) return;
    setBusy(true);
    try {
      await changePassword(form.current_password, form.new_password);
      setForm(EMPTY);
      toast.success(t("auth.passwordChanged"));
    } catch (err) {
      toast.error(describe(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard data-testid="password-card">
      <p className="label-xs">{t("auth.changePassword")}</p>
      <form className="mt-4 space-y-4" onSubmit={submit}>
        <PasswordInput
          data-testid="current-password"
          required
          placeholder={t("auth.currentPassword")}
          value={form.current_password}
          onChange={(e) => setForm({ ...form, current_password: e.target.value })}
        />
        <PasswordPair
          testId="new-password"
          password={form.new_password}
          confirm={form.confirm_password}
          onPasswordChange={(new_password) => setForm({ ...form, new_password })}
          onConfirmChange={(confirm_password) => setForm({ ...form, confirm_password })}
        />
        <NeuButton
          variant="primary"
          type="submit"
          data-testid="password-save"
          disabled={!ready}
          className="w-full justify-center py-3 sm:w-auto sm:px-6"
        >
          {t("app.save")}
        </NeuButton>
      </form>
    </NeuCard>
  );
};
